import { Card, CardContent } from "@/components/ui/Card"

// Grey bars where today's page content would sit. The wireframe is about
// getting around, not about what each page shows.
export default function PlaceholderPage() {
  return (
    <Card>
      <CardContent className="flex flex-col gap-3 p-6">
        {[92, 78, 85, 64, 88, 71].map((w, i) => (
          <div key={i} className="h-6 rounded-md bg-muted" style={{ width: `${w}%` }} />
        ))}
      </CardContent>
    </Card>
  )
}
